export const dataTable = {
  columns: [
    {
      label: "Indicadores",
      field: "name",
    },
    {
      label: "Categoria",
      field: "category",
    },

    {
      label: "Opciones",
      field: "options",
    },
  ],
  rows: [],
}
